<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crtf"><a class="page" id="piv"></a>The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2019 by Deirdre Nansen McCloskey</p>
<p class="crt">Appendix © 2019 by Stephen T. Ziliak</p>
<p class="crtf">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.</p>
<p class="crtf">Earlier versions of this book were previously published by Macmillan (1986) and Waveland Press (1999). Any questions concerning permissions should be directed to the Permissions Department at The University of Chicago Press, Chicago, IL.</p>
<p class="crtf">Published 2019</p>
<p class="crtf">Printed in the United States of America</p>
<p class="crtf">28 27 26 25 24 23 22 21 20 19    1 2 3 4 5</p>
<p class="crtf">ISBN-13: 978-0-226-44807-7 (paper)</p>
<p class="crt">ISBN-13: 978-0-226-44810-7 (e-book)</p>
<p class="crt">DOI: <a class="url" href="https://doi.org/10.7208/chicago/9780226448107.001.0001" target="_blank">https://doi.org/10.7208/chicago/9780226448107.001.0001</a></p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: McCloskey, Deirdre N., author. | Ziliak, Stephen Thomas, 1963–</p>
<p class="cip">Title: Economical writing / Deirdre Nansen McCloskey ; with an appendix by Stephen T. Ziliak.</p>
<p class="cip">Other titles: Chicago guides to writing, editing, and publishing.</p>
<p class="cip">Description: Third edition. | Chicago : The University of Chicago Press, 2019. | Series: Chicago guides to writing, editing, and publishing | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: LCCN 2018048196 | ISBN 9780226448077 (pbk. : alk. paper) | ISBN 9780226448107 (e-book)</p>
<p class="cip">Subjects: LCSH: Economics—Authorship. | English language—Composition and exercises. | Academic writing.</p>
<p class="cip">Classification: LCC PE1479.E35 M33 2019 | DDC 808.06/633—dc23</p>
<p class="cip">LC record available at <a class="url" href="https://lccn.loc.gov/2018048196" target="_blank">https://lccn.loc.gov/2018048196</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of ANSI<span class="sm">/</span>NISO Z39.48-1992 (Permanence of Paper).</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-mccloskey-0005.vue?5bcd0d97